import {api} from './api'

export interface NotificationsResponse {
    notifications: any[]
    total: number
    unreadCount: number
    hasMore: boolean
}

export const getNotifications = async (params: {
    filter?: 'all' | 'unread',
    limit?: number,
    offset?: number
}): Promise<NotificationsResponse> => {
    try {
        const queryParams = new URLSearchParams()
        if (params.filter) queryParams.append('filter', params.filter)
        if (params.limit) queryParams.append('limit', params.limit.toString())
        if (params.offset) queryParams.append('offset', params.offset.toString())

        const response = await api.get(`/api/notifications?${queryParams.toString()}`)
        return response.data.data || {notifications: [], total: 0, unreadCount: 0, hasMore: false}
    } catch (error) {
        console.error('Error fetching notifications:', error)
        return {notifications: [], total: 0, unreadCount: 0, hasMore: false}
    }
}

export const getUnreadCount = async (): Promise<number> => {
    try {
        // ✅ تأكد من الرابط
        const response = await api.get('/api/notifications/unread/count')
        return response.data.data?.count || 0
    } catch (error) {
        console.error('Error fetching unread count:', error)
        return 0
    }
}

export const markAsRead = async (id: number): Promise<boolean> => {
    try {
        const response = await api.post(`/api/notifications/${id}/read`)
        return response.data.success
    } catch (error) {
        console.error('Error marking as read:', error)
        return false
    }
}

export const markAllAsRead = async (): Promise<boolean> => {
    try {
        const response = await api.post('/api/notifications/read-all')
        return response.data.success
    } catch (error) {
        console.error('Error marking all as read:', error)
        return false
    }
}

export const deleteNotification = async (id: number): Promise<boolean> => {
    try {
        const response = await api.delete(`/api/notifications/${id}`)
        return response.data.success
    } catch (error) {
        console.error('Error deleting notification:', error)
        return false
    }
}

export const deleteReadNotifications = async (): Promise<boolean> => {
    try {
        const response = await api.delete('/api/notifications/read')
        return response.data.success
    } catch (error) {
        console.error('Error deleting read notifications:', error)
        return false
    }
}